import apiClient from "../clinet";

// Get all posts
const getPosts = async () => {
  const response = await apiClient.get("/posts");
  return response.data;
};

// Get single post by ID
const getPostById = async (id: string | number) => {
  const response = await apiClient.get(`/posts/${id}`);
  return response.data;
};

// Create new post
const createPost = async (postData: any) => {
  const response = await apiClient.post("/posts", postData);
  return response.data;
};

// Update post
const updatePost = async ({ id, data }: { id: string | number; data: any }) => {
  const response = await apiClient.put(`/posts/${id}`, data);
  return response.data;
};

// Delete post
const deletePost = async (id: string | number) => {
  const response = await apiClient.delete(`/posts/${id}`);
  return response.data;
};

export default {
  getPosts,
  getPostById,
  createPost,
  updatePost,
  deletePost,
};
